module.exports = __webpack_public_path__ + "static/finalize-d99fe8246ec36dfa5078a3dfe86b2cdf.svg";